var j = Object.defineProperty;
var U = (e, t, s) => t in e ? j(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s;
var _ = (e, t, s) => U(e, typeof t != "symbol" ? t + "" : t, s);
import { j as g } from "./jsx-runtime-3tyXYecC.mjs";
import { d as P } from "./index-DH8DM7A9.mjs";
import { l as d } from "./lodash-5ofSKtz3.mjs";
import { Component as M, createContext as W, createRef as $, Fragment as Z } from "react";
import { createPortal as q } from "react-dom";
function Y(e, t, s) {
  const { side: n } = s;
  if (n === "top" || n === "bottom")
    e.style.width = `${t.right - t.left}px`;
  else if (n === "left" || n === "right")
    e.style.height = `${t.bottom - t.top}px`;
  else
    throw new Error(`Could not modify attachment. Expected one of "top", "left", "bottom", or "right", got: "${n}".`);
}
class D extends M {
  constructor() {
    super(...arguments);
    _(this, "_handleResize", d.debounce(
      () => {
        this._lock();
      },
      20,
      { leading: !0 }
    ));
    _(this, "_handleScroll", d.debounce(
      () => {
        this._lock();
      },
      20,
      { leading: !0 }
    ));
  }
  _addEventListeners() {
    window.addEventListener("resize", this._handleResize), window.addEventListener("scroll", this._handleScroll);
  }
  _lock() {
    const { onLock: s } = this.props;
    s();
  }
  _removeEventListeners() {
    window.removeEventListener("resize", this._handleResize), window.removeEventListener("scroll", this._handleScroll);
  }
  componentDidMount() {
    const { isEnabled: s } = this.props;
    s && this._addEventListeners();
  }
  componentDidUpdate() {
    const { isEnabled: s } = this.props;
    s ? this._addEventListeners() : this._removeEventListeners();
  }
  componentWillUnmount() {
    this._removeEventListeners();
  }
  render() {
    const { children: s } = this.props;
    return s || null;
  }
}
_(D, "defaultProps", {
  isEnabled: !1
});
const l = Object.freeze({
  BOTTOM: "bottom",
  CENTER: "center",
  LEFT: "left",
  MIDDLE: "middle",
  RIGHT: "right",
  TOP: "top"
}), p = Object.freeze({
  CONSTRAIN: "constrain",
  CUSTOM: "custom",
  FLIP: "flip",
  SLIDE: "slide"
});
function B(e, t, s = {}) {
  return {
    ...J(e, t, s),
    ...K(e, t)
  };
}
function J(e, t, s = {}) {
  const n = {}, { anchor: i, vessel: o } = t, { anchor: r, vessel: a } = e, h = r.right - r.left, c = a.right - a.left;
  return i.horizontal === "left" ? n.left = r.left : i.horizontal === "center" ? n.left = r.left + h / 2 : (n.left = r.right, typeof (s == null ? void 0 : s.left) == "number" && (n.left += s.left)), o.horizontal === "center" ? n.left -= c / 2 : o.horizontal === "right" && (n.left -= c), n.right = n.left + c, n;
}
function K(e, t) {
  const s = {}, { anchor: n, vessel: i } = t, { anchor: o, vessel: r } = e, a = o.bottom - o.top, h = r.bottom - r.top;
  return n.vertical === "top" ? s.top = o.top : n.vertical === "middle" ? s.top = o.top + a / 2 : s.top = o.bottom, i.vertical === "middle" ? s.top -= h / 2 : i.vertical === "bottom" && (s.top -= h), s.bottom = s.top + h, s;
}
function I(e) {
  if (!d.isObject(e) || !d.isNumber(e.bottom) || !d.isNumber(e.left) || !d.isNumber(e.right) || !d.isNumber(e.top))
    throw new Error('Offsets must be an object containing numeric: "bottom", "left", "right", and "top" properties');
}
function y(e) {
  return I(e), {
    height: e.bottom - e.top,
    width: e.right - e.left
  };
}
function Q() {
  return {
    bottom: window.innerHeight,
    left: 0,
    right: window.innerWidth,
    top: 0
  };
}
function L(e) {
  const t = document.body.getBoundingClientRect(), s = e === window ? Q() : e.getBoundingClientRect(), n = y(s), i = s.top - t.top, o = s.left - t.left;
  return {
    bottom: i + n.height,
    left: o,
    right: o + n.width,
    top: i
  };
}
function X(e) {
  if (!d.isObject(e))
    throw new Error('The "elements" argument is missing an "anchor" value');
  if (!(e.anchor instanceof HTMLElement))
    throw new Error(`The "elements" argument doesn't reference an "anchor" element`);
  if (!(e.vessel instanceof HTMLElement))
    throw new Error(`The "elements" argument doesn't reference a "vessel" element`);
  if (e.container && !(e.container instanceof HTMLElement || e.container === window))
    throw new Error(`The "elements" argument doesn't reference a valid "container" element`);
  return {
    anchor: L(e.anchor),
    container: e.container ? L(e.container) : null,
    vessel: L(e.vessel)
  };
}
function ee(e, t) {
  const s = !(t.bottom <= e.top || e.bottom <= t.top), n = !(t.right <= e.left || e.right <= t.left);
  return s && n;
}
function b(e, t) {
  const s = [];
  return I(e), I(t), t[l.TOP] < e[l.TOP] && s.push(l.TOP), t[l.BOTTOM] > e[l.BOTTOM] && s.push(l.BOTTOM), t[l.LEFT] < e[l.LEFT] && s.push(l.LEFT), t[l.RIGHT] > e[l.RIGHT] && s.push(l.RIGHT), s;
}
function k(e) {
  return b(e.container, e.anchor).length > 0;
}
const C = 4;
function te(e) {
  const { collisions: t, locations: s, offsets: n } = e, i = { ...n };
  return s.vessel.vertical === "top" && t.includes("bottom") ? i.vessel.bottom = i.container.bottom - C : s.vessel.vertical === "bottom" && t.includes("top") && (i.vessel.top = Math.min(i.anchor.top, i.container.top + C), i.vessel.bottom = i.anchor.top), { offsets: i };
}
const u = Object.freeze({
  [l.BOTTOM]: l.TOP,
  [l.CENTER]: l.CENTER,
  [l.LEFT]: l.RIGHT,
  [l.RIGHT]: l.LEFT,
  [l.MIDDLE]: l.MIDDLE,
  [l.TOP]: l.BOTTOM
}), se = {
  align: "start",
  side: "bottom"
}, ne = [p.FLIP, p.CONSTRAIN], V = "flex", S = "none";
function ie(e) {
  const t = u[e.anchor.horizontal] || e.anchor.horizontal, s = u[e.vessel.horizontal] || e.vessel.horizontal;
  return {
    anchor: { ...e.anchor, horizontal: t },
    vessel: { ...e.vessel, horizontal: s }
  };
}
function oe(e) {
  const t = e.includes(l.LEFT), s = e.includes(l.RIGHT);
  return t && !s || s && !t;
}
function le(e) {
  const t = u[e.anchor.vertical] || e.anchor.vertical, s = u[e.vessel.vertical] || e.vessel.vertical;
  return {
    anchor: { ...e.anchor, vertical: t },
    vessel: { ...e.vessel, vertical: s }
  };
}
function re(e) {
  const t = e.includes(l.TOP), s = e.includes(l.BOTTOM);
  return t && !s || s && !t;
}
function z(e, t, s) {
  const { collisions: n, offsets: i, locations: o } = e, r = t(o), a = B(i, r, s), h = b(i.container, a), c = h.length < n.length;
  return {
    collisions: h,
    offsets: {
      ...i,
      vessel: c ? a : i.vessel
    },
    locations: c ? r : o
  };
}
function ce(e) {
  const { additionalVesselOffsets: t, collisions: s, offsets: n, locations: i } = e;
  let o = {
    offsets: {
      anchor: n.anchor,
      vessel: n.vessel
    },
    locations: i
  };
  return s.length > 0 && (oe(s) && (e = z(e, ie, t)), re(s) && (e = z(e, le, t)), o = {
    offsets: d.omit(e.offsets, ["container"]),
    locations: e.locations
  }), o;
}
const R = {
  bottom: "end",
  center: "center",
  left: "start",
  middle: "center",
  top: "start",
  right: "end"
};
function A(e) {
  return e.horizontal === l.LEFT || e.horizontal === l.RIGHT;
}
function x(e) {
  return e.vertical === l.TOP || e.vertical === l.BOTTOM;
}
function ae(e = {}) {
  const { anchor: t, vessel: s } = e;
  let n = null;
  if (t.horizontal === u[s.horizontal] && (n = {
    align: R[s.vertical],
    side: t.horizontal
  }), t.vertical === u[s.vertical] && (n = {
    align: R[s.horizontal],
    side: t.vertical
  }), n === null || !n.align || !n.side)
    throw new Error("An invalid location was supplied.");
  return n;
}
function he(e, t, s) {
  return (e === l.LEFT || e === l.RIGHT) && !k(t) && x(s.anchor) && x(s.vessel);
}
function de(e, t) {
  const { container: s, vessel: n } = t, i = y(n), o = { ...n };
  return e === l.LEFT ? (o.left = s.left, o.right = s.left + i.width) : e === l.RIGHT && (o.left = s.right - i.width, o.right = s.right), o;
}
function fe(e, t, s) {
  return (e === l.TOP || e === l.BOTTOM) && !k(t) && A(s.anchor) && A(s.vessel);
}
function ue(e, t) {
  const { container: s, vessel: n } = t, i = y(n), o = { ...n };
  return e === l.TOP ? (o.top = s.top, o.bottom = s.top + i.height) : e === l.BOTTOM && (o.top = s.bottom - i.height, o.bottom = s.bottom), o;
}
function me({ collisions: e, offsets: t, locations: s }) {
  const n = d.first(e);
  if (e.length === 1) {
    let { vessel: i } = t;
    he(n, t, s) ? i = de(n, t) : fe(n, t, s) && (i = ue(n, t));
    const o = { ...t, vessel: i };
    ee(o.anchor, o.vessel) || (t = o);
  }
  return {
    offsets: t,
    locations: s
  };
}
function pe(e, t, s = [], n) {
  const i = {
    locations: t,
    offsets: e
  }, o = e.container ? b(e.container, e.vessel) : [];
  return e.container || s.length || o.length ? s.reduce((r, a) => {
    const h = b(e.container, r.offsets.vessel), c = { additionalVesselOffsets: n, collisions: h, locations: t, offsets: e };
    let f;
    if (!h.length)
      return r;
    if (d.isFunction(a))
      f = a(c);
    else if (a === p.CONSTRAIN)
      f = te(c);
    else if (a === p.FLIP)
      f = ce(c);
    else if (a === p.SLIDE)
      f = me(c);
    else
      throw new Error(`Could not fix collisions. Unsupported strategy "${a}" encountered.`);
    return f ? { locations: t, offsets: e, ...f } : r;
  }, i) : i;
}
const N = {
  center: "center",
  end: "right",
  start: "left"
}, H = {
  center: "middle",
  end: "bottom",
  start: "top"
};
function ve(e) {
  const { align: t = "start", side: s = "top" } = e;
  let n = null;
  if ((s === "top" || s === "bottom") && (n = {
    anchor: {
      horizontal: N[t],
      vertical: s
    },
    vessel: {
      vertical: u[s],
      horizontal: N[t]
    }
  }), (s === "left" || s === "right") && (n = {
    anchor: {
      horizontal: s,
      vertical: H[t]
    },
    vessel: {
      horizontal: u[s],
      vertical: H[t]
    }
  }), n === null || !n.anchor.horizontal || !n.anchor.vertical || !n.vessel.horizontal || !n.vessel.vertical)
    throw new Error("An invalid placement was supplied.");
  return n;
}
function Ee(e, t, s = {}) {
  const { collisionStrategies: n = [], offset: i, isAttached: o } = s, r = e.vessel.cloneNode(!0), a = e.vessel.querySelectorAll("img");
  r.querySelectorAll("img").forEach((m, E) => {
    m.height = a[E].height, m.width = a[E].width, m.src = "";
  }), r.style.visibility = "hidden", r.style.removeProperty("height"), r.style.removeProperty("width"), e.vessel.parentNode.appendChild(r);
  const c = X({ ...e, vessel: r });
  r.remove(), o && (t.side === "top" || t.side === "bottom" ? (c.vessel.left = c.anchor.left, c.vessel.right = c.anchor.right) : (t.side === "left" || t.side === "right") && (c.vessel.top = c.anchor.top, c.vessel.bottom = c.anchor.bottom));
  const f = ve(t), O = {
    ...c,
    vessel: B(c, f, i)
  }, { locations: v, offsets: w } = pe(O, f, n, i);
  return {
    offsets: w,
    placement: ae(v)
  };
}
function _e(e, t) {
  e.style.position = "absolute", e.style.left = `${t.left}px`, e.style.top = `${t.top}px`, e.style.height = `${t.bottom - t.top}px`;
}
const G = W({}), Ie = ({ children: e, ...t }) => /* @__PURE__ */ g.jsx(G.Provider, { value: t, children: e }), T = class T extends M {
  constructor(t) {
    super(t), this._handleCollisionLock = () => {
      this.setState((n) => {
        const { appliedPlacement: i } = n;
        return {
          lockedPlacement: i
        };
      });
    }, this._anchorRef = $();
    const { isVisible: s } = t;
    this.state = {
      hasBeenVisible: s
    }, this._vesselElement = document.createElement("div"), this._vesselElement.style.visibility = "hidden", t["data-fabric-component"] && (this._vesselElement.dataset.fabricComponent = t["data-fabric-component"]), this._elements = {};
  }
  _insertVesselElement() {
    const { id: t = "", parentId: s } = this.props, n = s ? document.querySelector(`[data-helium-id="${s}"]`) : null, i = s ? null : document.querySelector(`[data-helium-parent-id="${t}"]`);
    n ? document.body.insertBefore(this._vesselElement, n.nextElementSibling) : i ? document.body.insertBefore(this._vesselElement, i) : document.body.appendChild(this._vesselElement);
  }
  _makeVesselVisible() {
    window.requestAnimationFrame(() => {
      this._vesselElement.style.visibility = "visible";
    });
  }
  _getCollisionStrategies(t) {
    const { collisionStrategies: s } = this.props;
    let n = s;
    const { collisionStrategies: i } = this.context;
    return (!n || n.length === 0) && (n = i || ne), t ? n.filter((o) => o === "constrain") : n;
  }
  _calculatePosition() {
    const { isAttached: t, offset: s, placement: n } = this.props, { lockedPlacement: i } = this.state, o = i || n;
    return Ee(this._elements, o, {
      collisionStrategies: this._getCollisionStrategies(i),
      isAttached: t,
      offset: s
    });
  }
  _attemptReposition() {
    const { isVisible: t } = this.props;
    window.requestAnimationFrame(() => {
      if (this._mounted && t && this._vesselElement.style.display !== "none") {
        const n = this._oldPosition, i = this._oldPosition = this._calculatePosition();
        d.isEqual(i, n) ? this._vesselElement.style.visibility === "hidden" && this._makeVesselVisible() : this._reposition(i), this._attemptReposition();
      }
    });
  }
  _reposition(t) {
    const { isAttached: s } = this.props, { offsets: n, placement: i } = t;
    s && Y(this._elements.vessel, n.anchor, i), _e(this._elements.vessel, n.vessel), this.setState(
      {
        appliedPlacement: i,
        appliedOffsets: n
      },
      () => {
        this._makeVesselVisible();
      }
    );
  }
  _show() {
    this._attemptReposition(), this._updateVesselZIndex();
  }
  _hide() {
    this._vesselElement.style.visibility = "hidden", this._vesselElement.style.height = "", this._vesselElement.style.width = "", this._oldPosition = void 0, this.setState({ lockedPlacement: null });
  }
  _updateElements() {
    const { collisionContainer: t } = this.props;
    this._elements = {
      anchor: this._anchorRef.current,
      container: t,
      vessel: this._vesselElement
    };
  }
  _updateVesselElement() {
    var o, r;
    const { id: t, parentId: s, isVisible: n } = this.props, i = this._vesselElement;
    i && (t && !i.dataset.heliumId && (i.dataset.heliumId = t), s && !i.dataset.heliumParentId && (i.dataset.heliumParentId = s), n && ((o = i.style) == null ? void 0 : o.display) !== V ? (i.style.display = V, i.style.flexDirection = "column") : !n && ((r = i.style) == null ? void 0 : r.display) !== S && (i.style.display = S));
  }
  _updateVesselZIndex() {
    const t = this._vesselElement, s = P.getMaxZIndex(), n = s + 10;
    s !== this._lastZIndex && (t.style.zIndex = this._lastZIndex = n);
  }
  componentDidMount() {
    const { isVisible: t } = this.props;
    this._mounted = !0, t && this._insertVesselElement(), this._updateElements(), this._updateVesselElement(), t && this._show();
  }
  componentDidUpdate(t) {
    const { hasBeenVisible: s } = this.state, { isVisible: n } = this.props, { isVisible: i } = t;
    this._updateElements(), this._updateVesselElement(), n ? (s || (this._insertVesselElement(), this.setState({ hasBeenVisible: !0 })), i || this._show()) : i && !n && this._hide();
  }
  componentWillUnmount() {
    this._mounted = !1, P.remove(this._vesselElement);
  }
  render() {
    const { isFullWidth: t, isInline: s, placement: n, renderAnchor: i, renderVessel: o, useCollisionLock: r, isVisible: a } = this.props, { lockedPlacement: h, hasBeenVisible: c, appliedOffsets: f, appliedPlacement: O } = this.state, v = O || n, w = d.isFunction(o) && (c || a === !0), m = r && a && !h, E = q;
    return /* @__PURE__ */ g.jsxs(D, { isEnabled: m, onLock: this._handleCollisionLock, children: [
      /* @__PURE__ */ g.jsx(
        "div",
        {
          ref: this._anchorRef,
          style: {
            display: s ? "inline-block" : "block",
            width: t ? "100%" : void 0
          },
          children: i({ appliedPlacement: v, appliedOffsets: f })
        },
        "anchor"
      ),
      w && E(/* @__PURE__ */ g.jsx(Z, { children: o({ appliedPlacement: v, appliedOffsets: f }) }), this._vesselElement)
    ] });
  }
};
T.defaultProps = {
  collisionContainer: window,
  isAttached: !1,
  isInline: !0,
  isVisible: !1,
  placement: se,
  useCollisionLock: !0
}, T.contextType = G;
let F = T;
export {
  F as H,
  Ie as a
};
//# sourceMappingURL=helium-B4JtMIBI.mjs.map
